/* Queries */
import { sbRespRoot } from '../../queries/sbRespRoot';

/* Reducers */
import { defaultReducers, actionSanitizer } from '../../reducers/reducerUtils';
import { sbSharedReducers } from '../../reducers/sbSharedReducers';
import { sbRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/sbRespNotificationsReducer';

/* Components */
import { SbRespLayout } from '../../finding/SbRespLayout/SbRespLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { datadog, initSharedDatadogRum, sbTypes } from 'dibs-datadog/exports/datadog';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';
import SV from 'server-vars';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2';

/* Notifications */
import { sbRespNotifications } from '../../finding/SbRespNotifications/sbRespNotifications';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    notifications: sbRespNotifications,
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
        sharedNotificationsReducer,
    },
    state: SV.get('storeState'),
    actionSanitizer,
};
const isSearch = (SV.get('relay.variables.uriRef') || '').startsWith('/search/');
datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        device: 'resp',
        page: PAGE_TYPE.BROWSE,
        pageSubType: isSearch ? sbTypes.search : sbTypes.browse,
    });
    setDatadogABTestValues();
});
initializeDBL(options).then(({ store, queue, actions }) => {
    createEntry({
        Container: SbRespLayout,
        store,
        query: sbRespRoot,
        containerId: 'page',
        queue,
        actions,
    });
});
